module.exports = __webpack_public_path__ + "img/screen1.8d78cc1.png";